// SuppressedCell — renders the R3 footer-aggregate pattern.
// Per-cell placeholders would re-introduce absentee inference; we only show a single
// aggregate count of suppressed cells beneath the visible data.
import { ShieldOff } from 'lucide-react';

export function SuppressedCell({ count }: { count: number }) {
  if (!count || count <= 0) return null;
  return (
    <div className="mt-3 flex items-center gap-2 rounded-md border border-dashed border-border bg-muted/40 px-3 py-2 text-xs text-muted-foreground">
      <ShieldOff className="h-3.5 w-3.5" />
      <span>
        {count} cell{count === 1 ? '' : 's'} hidden to protect identity (k &lt; 5).
      </span>
    </div>
  );
}
